/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActivateObject200,
  CreateObject200,
  CreateObjectRequest,
  DeactivateObject200,
  GetObject200,
  PagedResponsePhysicalObject,
  PhysicalObject,
  SearchObjectsParams,
  UpdateObject200,
  UpdateObjectRequest
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List objects for the caller's organisation
 */
export const listObjects = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<PhysicalObject[]>(
      {url: `/api/v1/objects`, method: 'GET', signal
    },
      );
    }
  



export const getListObjectsQueryKey = () => {
    return [
    `/api/v1/objects`
    ] as const;
    }

    
export const getListObjectsQueryOptions = <TData = Awaited<ReturnType<typeof listObjects>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listObjects>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListObjectsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listObjects>>> = ({ signal }) => listObjects(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listObjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListObjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listObjects>>>
export type ListObjectsQueryError = unknown


export function useListObjects<TData = Awaited<ReturnType<typeof listObjects>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listObjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listObjects>>,
          TError,
          Awaited<ReturnType<typeof listObjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListObjects<TData = Awaited<ReturnType<typeof listObjects>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listObjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listObjects>>,
          TError,
          Awaited<ReturnType<typeof listObjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListObjects<TData = Awaited<ReturnType<typeof listObjects>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listObjects>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List objects for the caller's organisation
 */

export function useListObjects<TData = Awaited<ReturnType<typeof listObjects>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listObjects>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListObjectsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Register a new physical object for the caller's organisation
 */
export const createObject = (
    createObjectRequest: CreateObjectRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateObject200>(
      {url: `/api/v1/objects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createObjectRequest, signal
    },
      );
    }
  


export const getCreateObjectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createObject>>, TError,{data: CreateObjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createObject>>, TError,{data: CreateObjectRequest}, TContext> => {

const mutationKey = ['createObject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createObject>>, {data: CreateObjectRequest}> = (props) => {
          const {data} = props ?? {};

          return  createObject(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateObjectMutationResult = NonNullable<Awaited<ReturnType<typeof createObject>>>
    export type CreateObjectMutationBody = CreateObjectRequest
    export type CreateObjectMutationError = unknown

    /**
 * @summary Register a new physical object for the caller's organisation
 */
export const useCreateObject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createObject>>, TError,{data: CreateObjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createObject>>,
        TError,
        {data: CreateObjectRequest},
        TContext
      > => {

      const mutationOptions = getCreateObjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single object
 */
export const getObject = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetObject200>(
      {url: `/api/v1/objects/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetObjectQueryKey = (id?: string,) => {
    return [
    `/api/v1/objects/${id}`
    ] as const;
    }

    
export const getGetObjectQueryOptions = <TData = Awaited<ReturnType<typeof getObject>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetObjectQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getObject>>> = ({ signal }) => getObject(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getObject>>>
export type GetObjectQueryError = unknown


export function useGetObject<TData = Awaited<ReturnType<typeof getObject>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getObject>>,
          TError,
          Awaited<ReturnType<typeof getObject>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetObject<TData = Awaited<ReturnType<typeof getObject>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getObject>>,
          TError,
          Awaited<ReturnType<typeof getObject>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetObject<TData = Awaited<ReturnType<typeof getObject>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single object
 */

export function useGetObject<TData = Awaited<ReturnType<typeof getObject>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetObjectQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update an object (type, name, external reference, location — objectCode is immutable)
 */
export const updateObject = (
    id: string,
    updateObjectRequest: UpdateObjectRequest,
 ) => {
      
      
      return apiClient<UpdateObject200>(
      {url: `/api/v1/objects/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateObjectRequest
    },
      );
    }
  


export const getUpdateObjectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateObject>>, TError,{id: string;data: UpdateObjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateObject>>, TError,{id: string;data: UpdateObjectRequest}, TContext> => {

const mutationKey = ['updateObject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateObject>>, {id: string;data: UpdateObjectRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateObject(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateObjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateObject>>>
    export type UpdateObjectMutationBody = UpdateObjectRequest
    export type UpdateObjectMutationError = unknown

    /**
 * @summary Update an object (type, name, external reference, location — objectCode is immutable)
 */
export const useUpdateObject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateObject>>, TError,{id: string;data: UpdateObjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateObject>>,
        TError,
        {id: string;data: UpdateObjectRequest},
        TContext
      > => {

      const mutationOptions = getUpdateObjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Deactivate an object
 */
export const deactivateObject = (
    id: string,
 ) => {
      
      
      return apiClient<DeactivateObject200>(
      {url: `/api/v1/objects/${id}/deactivate`, method: 'PATCH'
    },
      );
    }
  


export const getDeactivateObjectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateObject>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateObject>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivateObject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateObject>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivateObject(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateObjectMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateObject>>>
    
    export type DeactivateObjectMutationError = unknown

    /**
 * @summary Deactivate an object
 */
export const useDeactivateObject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateObject>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateObject>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeactivateObjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Activate an object
 */
export const activateObject = (
    id: string,
 ) => {
      
      
      return apiClient<ActivateObject200>(
      {url: `/api/v1/objects/${id}/activate`, method: 'PATCH'
    },
      );
    }
  


export const getActivateObjectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateObject>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateObject>>, TError,{id: string}, TContext> => {

const mutationKey = ['activateObject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateObject>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  activateObject(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateObjectMutationResult = NonNullable<Awaited<ReturnType<typeof activateObject>>>
    
    export type ActivateObjectMutationError = unknown

    /**
 * @summary Activate an object
 */
export const useActivateObject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateObject>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateObject>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getActivateObjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Paginated, filterable object list for the main Object Registry list page
 */
export const searchObjects = (
    params?: SearchObjectsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponsePhysicalObject>(
      {url: `/api/v1/objects/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchObjectsQueryKey = (params?: SearchObjectsParams,) => {
    return [
    `/api/v1/objects/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchObjectsQueryOptions = <TData = Awaited<ReturnType<typeof searchObjects>>, TError = unknown>(params?: SearchObjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchObjects>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchObjectsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchObjects>>> = ({ signal }) => searchObjects(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchObjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchObjectsQueryResult = NonNullable<Awaited<ReturnType<typeof searchObjects>>>
export type SearchObjectsQueryError = unknown


export function useSearchObjects<TData = Awaited<ReturnType<typeof searchObjects>>, TError = unknown>(
 params: undefined |  SearchObjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchObjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchObjects>>,
          TError,
          Awaited<ReturnType<typeof searchObjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchObjects<TData = Awaited<ReturnType<typeof searchObjects>>, TError = unknown>(
 params?: SearchObjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchObjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchObjects>>,
          TError,
          Awaited<ReturnType<typeof searchObjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchObjects<TData = Awaited<ReturnType<typeof searchObjects>>, TError = unknown>(
 params?: SearchObjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchObjects>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable object list for the main Object Registry list page
 */

export function useSearchObjects<TData = Awaited<ReturnType<typeof searchObjects>>, TError = unknown>(
 params?: SearchObjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchObjects>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchObjectsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




